import React from 'react'

const CollectionReportDataList = () => {
  return (
    <div>
      
    </div>
  )
}

export default CollectionReportDataList
